import { render } from "./BpmnEvent.vue?vue&type=template&id=5f37a261&scoped=true"
import script from "./BpmnEvent.vue?vue&type=script&lang=js"
export * from "./BpmnEvent.vue?vue&type=script&lang=js"

import "./BpmnEvent.vue?vue&type=style&index=0&id=5f37a261&scoped=true&lang=css"
import "./BpmnEvent.vue?vue&type=style&index=1&id=5f37a261&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f37a261"]])

export default __exports__